<template>
  <div>
    <svg-icon class="location" name="location" width="12" height="12"></svg-icon>
    <span class="paragraph-s paragraph-dark-gray">{{ location }}</span>
  </div>
</template>

<script>

import 'top20common/distribution/icons/location';
export default {
  props: {
    location: {
      type: String,
      default: ''
    }
  }
};
</script>

<style lang="scss" scoped>
.location {
  margin-right: 5px;
}
</style>
